/**
 * Created by woo on 01/06/2017.
 */

const API_DOMAIN = process.env.REACT_APP_API_DOMAIN
const API_KOTLIN_DOMAIN = process.env.REACT_APP_KOTLIN_DOMAIN
const API_EP_API_DOMAIN = process.env.REACT_APP_EP_API_DOMAIN
const API_OFFICIAL_DOMAIN = process.env.REACT_APP_OFFICIAL_DOMAIN
const API_MAP_QQ_DOMAIN = process.env.REACT_APP_API_MAP_QQ_DOMAIN
const TENCENT_MAP_KEY = process.env.REACT_APP_TENCENT_MAP_KEY
const IMAGE_DOMAIN = 'https://images.sport147.cn'
const AD_DOMAIN = 'http://scoreboard-ad.sport147.cn'
const { REACT_APP_API_isDev, REACT_APP_API_ROLE_ID, REACT_APP_API_S } =
  process.env
if (REACT_APP_API_isDev) {
  sessionStorage.setItem('role_id', REACT_APP_API_ROLE_ID)
  sessionStorage.setItem('s', REACT_APP_API_S)
  sessionStorage.setItem('token', process.env.REACT_APP_TOKEN)
  if (!sessionStorage.getItem('club_id')) {
    sessionStorage.setItem('club_id', process.env.REACT_APP_API_CLUB_ID)
  }
}
export {
  API_DOMAIN,
  API_KOTLIN_DOMAIN,
  API_EP_API_DOMAIN,
  API_OFFICIAL_DOMAIN,
  API_MAP_QQ_DOMAIN,
  TENCENT_MAP_KEY,
  IMAGE_DOMAIN,
  AD_DOMAIN,
}



// WEBPACK FOOTER //
// ./src/config.js